$(function () {
    $('.tab-list-item').on('click', function () {
        let index = $('.tab-list-item').index(this);
        $('.tab-list-item').removeClass('is-btn-active');
        $(this).addClass('is-btn-active');
        $('.tab-contents').removeClass('is-contents-active');
        $('.tab-contents').eq(index).addClass('is-contents-active');
    });

    $('.slider-top').slick({
        infinite: true,
        dots: false,
        arrows: false,
        pauseOnHover: false,
        slidesToShow: 1,
        autoplay: true,
        speed: 5000,
        fade: true,
    });

    $('.slider').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 5, // 6枚のスライドを表示
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        dots: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.slider2').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 4, // 6枚のスライドを表示
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        dots: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });

    $('.slider3').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 1, // 6枚のスライドを表示
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        dots: false,
        variableWidth: false,
    });

    $('.slider4').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 4, // 6枚のスライドを表示
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        dots: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    });
});

$(document).ready(function () {
    var header = $('.headers');
    var headerOffset = 30;

    $(window).scroll(function () {
        if ($(window).scrollTop() > headerOffset) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }
    });
});

$(function () {
    $('.thumb-item').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.thumb-item-nav'
    });
    $('.thumb-item-nav').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.thumb-item',
        focusOnSelect: true,
    });
});

$(document).ready(function () {
    var menuVisible = false;
    // メニューボタンがクリックされたときの処理
    $('#menu-btn').click(function () {
        if (menuVisible) {
            // メニューが表示されている場合、隠す
            $('#menu').css('left', '-250px');
            // 通常のスクロールを有効にする
            $('body').css('overflow', 'auto');
            
        } else {
            // メニューが非表示の場合、表示する
            $('#menu').css('left', '0');
            // スクロールを無効にする
            $('body').css('overflow', 'hidden');
            $('.sp-menu-middle > ul > li').addClass('on').hide().each(function(index) {
                $(this).delay(100 * index).fadeIn(500);
            });
        }
        // メニューの表示状態を反転させる
        menuVisible = !menuVisible;
    });
    $('#close-menu').click(function () {
        $('.sp-menu-middle > ul > li').removeClass('on').hide().each(function(index) {
            $(this).delay(100 * index).fadeIn(500);
        });
        // メニューを隠す
        $('#menu').css('left', '-250px');
        // 通常のスクロールを有効にする
        $('body').css('overflow', 'auto');
        // メニューの表示状態を更新
        menuVisible = false;
    });
});

// $(document).ready(function () {
//     // サブメニューのアイコンがクリックされたときの処理
//     $('.submenu-icon').click(function (e) {
//         e.preventDefault();
//         // クリックされたメニューの直後のulを取得し、表示/非表示を切り替える
//         var submenu = $(this).closest('a').next('ul');
//         submenu.slideToggle();
//         // アイコンのテキストを切り替える
//         $(this).text(submenu.is(':visible') ? 'close' : 'add');
//     });
// });

$(function () {
    // 親
    $('.chiiki_menu > p').click(function () {
        $(this).next('ul').slideToggle('fast');
        $(this).toggleClass('show'); // Toggle the 'show' class on click
        updateSubMenuIcon($(this)); // Update the submenu icon
    });

    // 子
    $('.chiiki_menu > ul > li').click(function (e) {
        $(this).children('ul').slideToggle('fast');
        $(this).toggleClass('show'); // Toggle the 'show' class on click
        updateSubMenuIcon($(this)); // Update the submenu icon
        e.stopPropagation();
    });

    // Function to update the submenu icon
    function updateSubMenuIcon(element) {
        var icon = element.find('.submenu-icon');
        if (element.hasClass('show')) {
            icon.text('close'); // Change to 'close' when the parent has the 'show' class
        } else {
            icon.text('add'); // Change back to 'add' when the parent doesn't have the 'show' class
        }
    }
});


$(document).ready(function () {
    // ホバーしたときの処理
    $('.pc-menus ul li').hover(
        function () {
            // ホバー時に直下の .submenu をふわっと表示
            var submenu = $(this).find('.submenu');
            submenu.stop().fadeIn(500);

            // submenu内のliを順番にフェードイン
            submenu.find('ul li ul li').each(function (index) {
                $(this).delay(100 * index).fadeIn(500);
            });
        },
        function () {
            // ホバーから外れたときに非表示
            var submenu = $(this).find('.submenu');
            submenu.stop().fadeOut(500);

            // submenu内のliを非表示
            submenu.find('ul li ul li').hide();
        }
    );
});

$(document).ready(function () {
    // 質問をクリックしたときの処理
    $(".questions-each-q").click(function () {
      // クリックされた質問に対応する回答をトグル
      $(this).next(".questions-each-a").slideToggle();

      // アイコンの表示/非表示を切り替え
      $(this).find(".open-icon").toggle();
      $(this).find(".close-icon").toggle();
    });

    // 回答をクリックしたときの処理
    $(".questions-each-a").click(function () {
      // クリックされた回答に対応する質問をトグル
      $(this).prev(".questions-each-q").click();
    });
});

var viewMoreElements = document.querySelectorAll('.view-more');

viewMoreElements.forEach(function(viewMoreElement) {
    viewMoreElement.addEventListener('click', function(event) {
        // クリックされた要素内の<a>要素からhref属性を取得
        var targetUrl = event.currentTarget.querySelector('a').getAttribute('href');
        
        // ページ遷移
        window.location.href = targetUrl;
    });
});

document.getElementById('searchToggle').addEventListener('click', function() {
    var searchbox = document.querySelector('.searchbox');
    searchbox.style.display = (searchbox.style.display === 'none' || searchbox.style.display === '') ? 'block' : 'none';
});

document.getElementById('searchToggle2').addEventListener('click', function() {
    var searchbox = document.querySelector('.searchbox');
    searchbox.style.display = (searchbox.style.display === 'none' || searchbox.style.display === '') ? 'block' : 'none';
});

document.getElementById('close-search').addEventListener('click', function() {
    var searchbox = document.querySelector('.searchbox');
    searchbox.style.display = 'none';
});

document.getElementById('close-search2').addEventListener('click', function() {
    var searchbox = document.querySelector('.contact-finish-message');
    searchbox.style.display = 'none';
});


